import { createSelector } from '@reduxjs/toolkit';
import { selectDecimalPlaces } from '@ui/features/quote-builder/state/selectors/decimal-places';
import { selectAllIssues } from '@ui/features/quote-builder/state/selectors/issue';
import { RootState } from '@ui/store';

import { EditableQuoteBuilderRequirementField } from '../../types/state/requirement';
import { buildElementId } from '../utilities/element-id';
import {
  getIssues,
  getSnapRequirementOrThrow,
} from '../utilities/selector-guards';

export const selectSnapRequirementField = createSelector(
  [
    selectAllIssues,
    selectDecimalPlaces,
    (state: RootState, quoteLineUuid: string) =>
      state.quoteBuilder!.quoteLines[quoteLineUuid],
    (_, __, snapOperationUuid: string) => snapOperationUuid,
    (_, __, ___, snapRequirementUuid: string) => snapRequirementUuid,
    (_, ___, ____, _____, field: EditableQuoteBuilderRequirementField) => field,
  ],
  (
    issues,
    decimalPlaces,
    quoteLine,
    snapOperationUuid,
    snapRequirementUuid,
    field,
  ) => {
    const snapRequirement = getSnapRequirementOrThrow(
      quoteLine,
      snapOperationUuid,
      snapRequirementUuid,
    );

    const fieldIssues = getIssues(issues, {
      area: 'snapRequirement',
      quoteLineUuid: quoteLine.uuid,
      snapOperationUuid,
      snapRequirementUuid,
      field,
    });

    const elementId = buildElementId({
      uuid: snapRequirementUuid,
      field,
    });

    return {
      elementId,
      issues: fieldIssues,
      value: snapRequirement[field]?.toFixed(decimalPlaces) ?? '',
    };
  },
);
